<script>
import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'

import { TextareaBox as RichTextarea } from '@didi/rich-ui'
import { InputPreviewText } from '../PreviewText'
import { debounce } from 'lodash'
import { defineComponent, h } from 'vue-demi'

const DebounceTextarea = defineComponent({
  setup(props, { attrs, listeners }) {
    return () => {
      return h(RichTextarea, {
        props: { ...props },
        attrs: { ...attrs },
        on: {
          ...listeners,
          input: debounce((...args) => {
            listeners.input(...args)
          }),
        },
      })
    }
  },
})
const TransformRichTextarea = transformComponent(DebounceTextarea, {
  change: 'input',
})

export const Textarea = connect(
  TransformRichTextarea,
  mapProps({ readOnly: 'readonly' }, props => {
    return {
      showlength: props.showlength || true,
      showlengthPosition: props.showlengthPosition || 'inner',
      maxlength: props.maxlength,
      immediateInput: !!props.immediateInput,
    }
  }),
  mapReadPretty(InputPreviewText),
)

export default Textarea
</script>
<style lang="scss">
@import './style.scss';
</style>
